import { Check, Paperclip } from "lucide-react";
import { REQUEST_STATUS_LABELS, money, requestStatusTone, requestSteps } from "../../lib/procurement";

export function RequestStatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${requestStatusTone(status)}`} data-testid={`request-status-${status}`}>
      {REQUEST_STATUS_LABELS[status] || status}
    </span>
  );
}

// The happy path as a row of steps: where the request is, and what is still to come (a text for each, never colour alone).
export function RequestSteps({ status }) {
  const steps = requestSteps(status);
  return (
    <ol className="flex flex-wrap gap-x-1 gap-y-1.5" aria-label="Avancement de la demande" data-testid="request-steps">
      {steps.map((step) => (
        <li key={step.id} data-state={step.state} aria-current={step.state === "current" ? "step" : undefined}
          className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium ${
            step.state === "current" ? "border-jamora bg-jamora text-white" : step.state === "done" ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-slate-200 bg-white text-slate-500"}`}>
          {step.state === "done" && <Check size={12} aria-hidden="true" />}{step.label}
        </li>
      ))}
    </ol>
  );
}

export function Amount({ minor, currency, className = "" }) {
  return <span className={`tabular-nums ${className}`}>{money(minor, currency)}</span>;
}

// The private files of a quote or an invoice: opened through the server, which asks the request who may read them.
export function FileLinks({ files }) {
  if (!files?.length) return null;
  return (
    <span className="inline-flex flex-wrap gap-x-3 gap-y-1">
      {files.map((f) => (
        <a key={f.id} href={`/api/files/${f.id}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-jamora hover:underline" data-testid="request-file">
          <Paperclip size={12} aria-hidden="true" />{f.name}
        </a>
      ))}
    </span>
  );
}
